import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { theme } from './theme';
import { CssBaseline } from '@mui/material';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { LoginPage } from './pages/LoginPage';
import { WorkersPage } from './pages/WorkersPage';
import { WorkerDashboardPage } from './pages/WorkerDashboardPage';
import { CompaniesPage } from './pages/CompaniesPage';
import { AdminRoute } from './components/AdminRoute';



const PrivateRoute: React.FC<{ children: React.ReactNode; workerOnly?: boolean }> = ({ children, workerOnly = false }) => {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return <div>Cargando...</div>;
  }

  if (!user) return <Navigate to="/login" />;
  if (workerOnly && user.role !== 'Trabajador' && user.role !== 'worker') {
    return <Navigate to="/login" />;
  }
  return <>{children}</>;
};

const AppContent: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/workers"
          element={
            <PrivateRoute>
              <WorkersPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/me"
          element={
            <PrivateRoute workerOnly>
              <WorkerDashboardPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/companies"
          element={
            <AdminRoute>
              <CompaniesPage />
            </AdminRoute>
          }
        />
        <Route path="/" element={<Navigate to="/login" replace />} />
      </Routes>
    </Router>
  );
};

const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </ThemeProvider>
  );
};

export default App;
